import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";
Vue.use(Vuetify);

const theme = {
  primary: "#8BC34A",
  secondary: "#1B1B1B",
  accent: "#558B2F",
  info: "#2196F3",
  success: "#43A047",
  warning: "#FB8C00",
  error: "#E53935",
  default: "#1B1B1B",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false, // If you want to set dark theme then dark:true else set to false
  },
  rtl: false, // If you want to set rtl theme then rtl:true else set to false
});
